module.exports = __webpack_public_path__ + "img/rotate-counter-clockwise.a2215c7e.svg";